<template>
  <div>
    <Modal v-model="visible" width="800px" title="账户设置" :footer-hide="true" :mask-closable="false" class="my-modal top static">
      <loading :isShow="loading" />
      <Form ref="myForm" :model="formData" :label-width="100" class="page-form">
        <div class="form-title">账号信息</div>
        <FormItem label="登录账号" class="less">
          {{ detail.account }}
        </FormItem>
        <FormItem label="所属转介人" class="less">
          {{ detail.organizationName }}
        </FormItem>
        <FormItem label="角色" class="less">
          {{ detail.roles && detail.roles.join(',') }}
        </FormItem>
        <FormItem label="状态" class="less">
          <span v-if="detail.status == 1">有效</span>
          <span v-else-if="detail.status == 0">无效</span>
        </FormItem>
        <div class="form-title">基本信息</div>
        <FormItem label="密码" class="less">
          <Button type="primary" @click="togglePassword">修改密码</Button>
        </FormItem>
      </Form>
      <!-- <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="submit">提交</Button>
      </div> -->
    </Modal>
    <!-- 修改密码弹窗 -->
    <updatePwdModal ref="updatePwdModalRef" />
  </div>
</template>

<script>
import updatePwdModal from './updatePwdModal';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: { updatePwdModal },
  data() {
    return {
      visible: false,
      loading: false,
      detail: {},
      formData: {}
    };
  },
  methods: {
    async open() {
      this.getDetail();
      this.visible = true;
    },
    // 获取账户详情
    getDetail() {
      this.$http({
        type: 'GET',
        url: '/system/users/getAccountInfo',
        data: {}
      }).then(res => {
        this.detail = res.data;
        const formData = {
          userName: res.data.userName,
          englishName: res.data.englishName,
          mobile: res.data.mobile
        };
        this.formData = formData;
        this.clearValidate();
      });
    },
    submit() {
      this.$refs.myForm.validate().then(isok => {
        if (!isok) {
          return;
        }
        if (this.loading) {
          return;
        }
        this.loading = true;
        const formData = JSON.parse(JSON.stringify(this.formData));
        this.$http({
          type: 'POST',
          url: '/system/users/modifyAccount',
          data: formData
        })
          .then(res => {
            this.$emit('reload', formData);
            this.visible = false;
          })
          .finally(() => {
            window.setTimeout(() => {
              this.loading = false;
            }, 300);
          });
      });
    },
    // 切换密码弹窗
    togglePassword() {
      this.$refs.updatePwdModalRef.open();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
